import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import { fetchRecipes, fetchRecipeById, addRecipe, updateRecipe, deleteRecipe } from "./recipeThunk";

interface RecipeSliceState {
  recipes: any[];
  recipeDetails: any;
  rowCount: number;
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: RecipeSliceState = { recipes: [], recipeDetails: {}, rowCount: 0, status: ApiStatus.IDLE, errorMessage: "" };

const recipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipes.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchRecipes.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.recipes = Array.isArray(action.payload) ? action.payload : [];
        state.rowCount = state.recipes.length;
      })
      .addCase(fetchRecipes.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(fetchRecipeById.fulfilled, (state, action: any) => { state.recipeDetails = action.payload || {}; })

      .addCase(addRecipe.fulfilled, () => { toast.success("Recipe created"); })
      .addCase(addRecipe.rejected, (state, action) => { toast.error(action.error.message || "Failed to create recipe"); })
      .addCase(updateRecipe.fulfilled, () => { toast.success("Recipe updated"); })
      .addCase(updateRecipe.rejected, (state, action) => { toast.error(action.error.message || "Failed to update recipe"); })
      .addCase(deleteRecipe.fulfilled, () => { toast.success("Recipe deactivated"); })
      .addCase(deleteRecipe.rejected, (state, action) => { toast.error(action.error.message || "Failed to deactivate"); });
  },
});

export default recipeSlice.reducer;
